export default class requirementDetailModel {
    constructor({id, requirement, is_active, created_by, created_by_name, created_on, updated_by, updated_by_name, updated_on}) {
        this.id = id;
        this.requirement = requirement;
        this.is_active = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
        this.created_on = created_on;
        this.updated_by = updated_by;
        this.updated_by_name = updated_by_name;
        this.updated_on = updated_on;
    }
}